(function () {
  function open(modal) {
    if (!modal) return;
    // Move o modal para o fim do <body> para sair de qualquer stacking context
    // pai (variant-picker, buy-buttons, sticky bar, header) que cria overlap.
    // Sem isto, mesmo com z-index altíssimo, o modal fica "preso" dentro do
    // pai com z-index/transform/will-change que cria contexto isolado.
    if (modal.parentElement !== document.body) {
      modal.dataset.bshScReparented = '1';
      document.body.appendChild(modal);
    }
    modal.hidden = false;
    document.body.dataset.bshScPrevOverflow = document.body.style.overflow || '';
    document.body.style.overflow = 'hidden';
  }
  function close(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = document.body.dataset.bshScPrevOverflow || '';
    delete document.body.dataset.bshScPrevOverflow;
  }
  function init() {
    document.querySelectorAll('[data-bsh-sc-open]').forEach(function (btn) {
      if (btn.dataset.bshScBound) return;
      btn.dataset.bshScBound = '1';
      btn.addEventListener('click', function () {
        open(document.getElementById(btn.getAttribute('data-bsh-sc-open')));
      });
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-bsh-sc-close]')) {
      close(e.target.closest('.bsh-sc-modal'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.bsh-sc-modal:not([hidden])').forEach(close);
    }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
